export type NavigationNodeData = {
  title: string,
  url: string,
};

export const defaultNavigation = [
  {
    title: 'Customize',
    url: '/customize?q=1',
  },
  {
    title: 'reFills',
    url: '/refills',
  },
  {
    title: 'Boost',
    url: '/boost',
  },
  {
    title: 'Add-Ons',
    url: '/add-ons',
  },
];

export default defaultNavigation;
